import HttpV2 from './HttpV2';

class CampaignStatServiceV2 {
  static async getCampaignStats(campaignId) {
    return HttpV2.get(`campaign-stats/${campaignId}`);
  }
  static async getCampaignPreview(campaignId) {
    return HttpV2.put(`campaign-stats/${campaignId}/previews`);
  }
}

export default CampaignStatServiceV2;
